const container = "p-4 md:p-6 shrink-0 border-t border-border";

const header = "pb-0 sm:pb-0";

const title = "text-lg font-bold text-foreground";

const card = "flex flex-col h-full";

const content = "pt-0 flex-1 flex flex-col";

const historyList = "space-y-3 overflow-y-auto";

const emptyContainer = "flex-1 flex items-center justify-center";

const loadingContainer = "flex items-center justify-center py-8";

const loadingSpinner = "h-5 w-5 animate-spin text-muted-foreground";

const loadingText = "ml-2 text-sm text-muted-foreground";

const errorContainer = "flex flex-col items-center justify-center py-8 gap-3";

const errorIcon = "h-8 w-8 text-destructive";

const errorMessage = "text-xs text-muted-foreground max-w-sm text-center";

const retryButton = "flex items-center gap-1 text-xs text-primary hover:text-primary/80";

const retryIcon = "h-3 w-3";

export {
  container,
  header,
  title,
  card,
  content,
  historyList,
  emptyContainer,
  loadingContainer,
  loadingSpinner,
  loadingText,
  errorContainer,
  errorIcon,
  errorMessage,
  retryButton,
  retryIcon,
};
